import CareerTracksVariant from './career-tracks-variant'

export default CareerTracksVariant
